// extracted by mini-css-extract-plugin
export default {"container":"ImageAsColorPreview_container__6tUmu"};